import { z } from 'zod';
export const COUNTRIES = ['FRA', 'ESP', 'BEL'];
export function isAValidCountry(country) {
    return COUNTRIES.includes(country);
}
export const CountryZodSchema = z.enum(COUNTRIES);
//# sourceMappingURL=country.model.js.map